import React from "react";
import { useFieldArray } from "react-hook-form";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import Websites from "../websites/Websites";
import "./PreviewPages.css";

export default function Fields({ control, register }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "previewPages",
  });

  return (
    <div className="form-wrapper-preview-pages">
      <ul>
        {" "}
        <h4>Preview pages</h4>
        {fields.map((item, index) => {
          return (
            <li key={item.id}>
              <div className="input-container">
                <div className="inner-input-preview-pages-form-container">
                  <div className="wrapper-preview-pages-form">
                    <InputFieldFormArray
                      label="Preview pages title "
                      fieldRef={register(`previewPages[${index}].title`, {
                        required: false,
                      })}
                      name={`previewPages[${index}].title`}
                      key={item.id}
                    />

                    <p className="message">
                      Please only insert a title if there is a creative that
                      should be displayed on a specific preview page, otherwise
                      keep blank.
                    </p>
                    <button
                      className="add-preview-pages-button delete-button"
                      type="button"
                      onClick={() => {
                        remove(index);
                      }}
                    >
                      Delete preview page
                    </button>
                  </div>

                  <Websites {...{ control, register, index }} />
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      <section>
        <button
          className="append-button"
          type="button"
          onClick={() => {
            append({
              title: "",
              websites: [
                {
                  site: "",
                },
              ],
            });
          }}
        >
          Add preview pages
        </button>
      </section>
    </div>
  );
}
